export const FILTERS = ["all", "new", "contacted", "closed"];

export const filterEnquiries = (items, filter, query) => {
  const needle = query.toLowerCase();
  return items.filter((item) =>
    (filter === "all" || item.status === filter)
    && `${item.name} ${item.email} ${item.company} ${item.message}`.toLowerCase().includes(needle));
};

export const countEnquiries = (items) => Object.fromEntries(FILTERS.map((filter) => [
  filter, items.filter((item) => filter === "all" || item.status === filter).length,
]));